// extracted by mini-css-extract-plugin
export default {"root":"CustomLabel_root__AqvRY","table-headers":"CustomLabel_table-headers__838xY","table-data":"CustomLabel_table-data__OhhV7"};